import firebase from "../Firebase";
import { User } from "./../types/Types";
import { useCollectionData } from "react-firebase-hooks/firestore";
import { NavLink } from "react-router-dom";

const UserPresence = () => {
  const query = firebase.firestore().collection("users").orderBy("isOnline");
  const user = firebase.auth().currentUser;
  const [users] = useCollectionData(query, { idField: "id" });
  const userObj: Partial<User> =
    user != null
      ? {
          uid: user.uid,
          photoURL: user.photoURL,
          displayName: user.displayName,
          isOnline: true,
          isTyping: false,
        }
      : {};

  const userStatusFirestoreRef = firebase.firestore().doc("/users/" + userObj.uid);
  const userStatusDatabaseRef = firebase.database().ref("/users/" + userObj.uid);

  function changeUserStatus() {
    firebase
      .database()
      .ref(".info/connected")
      .on("value", async (snapshot) => {
        if (snapshot.val() === false) {
          userStatusFirestoreRef.set({ ...userObj, isOnline: false });
          return;
        }

        await userStatusDatabaseRef.onDisconnect().set({ ...userObj, isOnline: false });
        await userStatusDatabaseRef.set({ ...userObj });
        await userStatusFirestoreRef.set({ ...userObj });
      });
  }

  function showOnlineUsers() {
    const filteredUsers = users?.filter((user) => user.isOnline === true);
    return filteredUsers?.map((user) => (
      <NavLink activeClassName="active" className="nav-link-user" key={user.id} to={"/user/" + user.id}>
        <div className="users-item">
          <img className="users-img" src={user.photoURL} alt="" />
          <p className="users-name">{user.displayName}</p>
        </div>
      </NavLink>
    ));
  }

  user != null && changeUserStatus();

  return (
    <div className="users-container">
      <div className="users-title">Online users</div>

      {showOnlineUsers()}
      <NavLink to={"/"}>
        <p className="main-chat"> Back to the main chat</p>
      </NavLink>
    </div>
  );
};

export default UserPresence;
